import axios from "axios";
import Cookies from "js-cookie";

const getBaseURL = () => {
	let backendUrl = process.env.REACT_APP_BASE_API_URL;
	
	// Intelligent fallback for production if env variable is missing
	if (!backendUrl || backendUrl === "" || backendUrl.includes("localhost")) {
		if (window.location.hostname.includes("fameo-x.com")) {
			backendUrl = "https://fameo-x.com";
		} else {
			backendUrl = "http://localhost:5005";
		}
	}

	return backendUrl.endsWith("/api") ? backendUrl : `${backendUrl}/api`;
};

const getStoredToken = () => {
	try {
		const rawToken = Cookies.get("E_token");
		if (!rawToken || rawToken === "undefined" || rawToken === "null") return null;
		return JSON.parse(rawToken);
	} catch (e) {
		const rawToken = Cookies.get("E_token");
		return rawToken && rawToken !== "undefined" && rawToken !== "null" ? rawToken : null;
	}
};

const Instance = axios.create({
	baseURL: getBaseURL(),
	headers: {
		authorization: getStoredToken() || "",
	},
});

Instance.interceptors.request.use((config) => {
	const token = getStoredToken();
	if (token) {
		config.headers.authorization = token;
		config.headers.Authorization = token;
	}
	return config;
});

export default Instance;

// Do this after login
// axios.defaults.headers.Authorization = token


